var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart-title"},[_vm._v("住宅类销售比率")]),_c('div',{staticClass:"chart",attrs:{"id":_vm.item.soldAmount}})])
}
var staticRenderFns = []

export { render, staticRenderFns }